import { render } from "./stockCheck.vue?vue&type=template&id=6afa8c1c"
import script from "./stockCheck.vue?vue&type=script&lang=js"
export * from "./stockCheck.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__